import { collection, query, where, limit, onSnapshot } from 'firebase/firestore';

export function watchMyCases(db, uid, includeArchived, onData, onError) {
  const base = collection(db, 'cases');

  // T-54/T-64 FIX: Query both memberIds (modern) and ownerId (legacy) to catch all user cases.
  // Firestore doesn't support OR across different fields, so use three subscriptions and merge.
  // counselIds covers guests invited directly via the mobile app (addGuestMember CF).
  const memberQuery  = query(base, where('memberIds', 'array-contains', uid), limit(100));
  const ownerQuery   = query(base, where('ownerId', '==', uid), limit(100));
  const counselQuery = query(base, where('counselIds', 'array-contains', uid), limit(100));

  let memberDocs  = new Map();
  let ownerDocs   = new Map();
  let counselDocs = new Map();

  function mergeAndNotify() {
    // memberIds takes precedence over counselIds (same case, richer role)
    const merged = new Map([...counselDocs, ...ownerDocs, ...memberDocs]);
    let items = Array.from(merged.values());

    if (!includeArchived) {
      items = items.filter((c) => !c.archived);
    }

    items.sort((a, b) => {
      const ta = (a.updatedAt?.toMillis?.() || a.updatedAt?.seconds * 1000 || a.createdAt?.toMillis?.() || a.createdAt?.seconds * 1000 || 0);
      const tb = (b.updatedAt?.toMillis?.() || b.updatedAt?.seconds * 1000 || b.createdAt?.toMillis?.() || b.createdAt?.seconds * 1000 || 0);
      return tb - ta;
    });

    onData(items);
  }

  const unsubMember = onSnapshot(
    memberQuery,
    (snapshot) => {
      snapshot.docs.forEach((d) => memberDocs.set(d.id, { ...d.data(), id: d.id }));
      // Remove deleted docs
      const ids = new Set(snapshot.docs.map((d) => d.id));
      for (const id of memberDocs.keys()) {
        if (!ids.has(id)) memberDocs.delete(id);
      }
      mergeAndNotify();
    },
    onError
  );

  const unsubOwner = onSnapshot(
    ownerQuery,
    (snapshot) => {
      snapshot.docs.forEach((d) => ownerDocs.set(d.id, { ...d.data(), id: d.id }));
      const ids = new Set(snapshot.docs.map((d) => d.id));
      for (const id of ownerDocs.keys()) {
        if (!ids.has(id)) ownerDocs.delete(id);
      }
      mergeAndNotify();
    },
    onError
  );

  // Non-fatal: user may have no counselIds-style access. Errors here should not
  // block the case list — just silently skip guest cases if the query fails.
  const unsubCounsel = onSnapshot(
    counselQuery,
    (snapshot) => {
      snapshot.docs.forEach((d) => counselDocs.set(d.id, { ...d.data(), id: d.id }));
      const ids = new Set(snapshot.docs.map((d) => d.id));
      for (const id of counselDocs.keys()) {
        if (!ids.has(id)) counselDocs.delete(id);
      }
      mergeAndNotify();
    },
    () => mergeAndNotify() // non-fatal — user may have no guest cases
  );

  return () => {
    unsubMember();
    unsubOwner();
    unsubCounsel();
  };
}

